export const host = "https://trading.dsc.com.vn/"
// export const host = "wss://uat.dsc.com.vn/"

export const SDK_INFO = {
  '__sails_io_sdk_version': '1.2.1',
  '__sails_io_sdk_platform': 'browser',
  '__sails_io_sdk_language': 'javascript',
};

export const socketRoomName = {
  'instrument': "i",    //room publish thông tin mã chứng khoán
  'instrument_ol': "i_ol",    //room publish thông tin mã chứng khoán lô lẻ
  'trade': "t",         //room publish thông tin chi tiết khớp mã chứng khoán
  'trade_ol': "t_ol",         //room publish thông tin chi tiết khớp mã chứng khoán lô lẻ
  'orderBook10': "o10",   //room publish thông tin top10 giá mua giá bán mã chứng khoán
  'orderBook_ol10': "o_ol10",   //room publish thông tin top10 giá mua giá bán mã chứng khoán lô lẻ
  'orderBook3': "o3",    //room publish thông tin top3 giá mua giá bán mã chứng khoán
  'orderBook_ol3': "o_ol3",    //room publish thông tin top3 giá mua giá bán mã chứng khoán lô lẻ
  'orderBook': "o",    //Loại event publish thông tin top3 giá mua giá bán mã chứng khoán
  'orderBook_ol': "o_ol",    //Loại event publish thông tin top3 giá mua giá bán mã chứng khoán lô lẻ
  'exchange': "e",    //room subscribe thông tin mã chứng khoán theo sàn
  'exchange_ol': "e_ol",    //room subscribe thông tin mã chứng khoán lô lẻ theo sàn
  'index': "idx",          //room publish thông tin chỉ số
  'putthrough': "pth",  //room publish thông tin mua bán thỏa thuận theo sàn
  'ptmatch': "ptm",     //room publish thông tin mua bán thỏa thuận theo sàn

  'channel': "ch",      //room publish các loại thông tin cho các kênh kết nối dạng server2server

  // 'account': "acc",      //room publish tín hiệu thay đổi balance tiểu khoản
  // 'customer': "cus",    //room publish thông tin liên quan đến tài khoản (Vd: thông báo đã download báo cáo xong)
  // 'message': "msg",      //room publish thông điệp, cảnh báo liên quan tới tài khoản, hoặc các tiểu khoản
  // 'report': "rpt",      //Loại event report bắn chung vào room customer
  // 'message_analytic': "msg.analyt",      //room publish thông điệp tin phân tích do công ty ck soạn
};

export const socketAction = {    // socket action từ server trả về
  partial: "p",    // socket action partial
  update: "u",    // socket action update
  insert: "i",    // socket action insert
  delete: "d",    // socket action delete
  signal: "s",    // socket action signal
};

export const messageValueStock = {
  Id: 'Id',
  SB: 'SB', //symbol
  SI: 'SI',
  FN: 'FN',
  TD: 'TD',
  ST: 'ST',
  CL: 'CL',
  FL: 'FL',
  RE: 'RE',
  B3: 'B3',
  V3: 'V3',
  B2: 'B2',
  V2: 'V2',
  B1: 'B1',
  V1: 'V1',
  CP: 'CP', // close price
  CV: 'CV',
  CH: 'CH',
  CHP: 'CHP',
  S1: 'S1',
  U1: 'U1',
  S2: 'S2',
  U2: 'U2',
  S3: 'S3',
  U3: 'U3',
  TT: 'TT', // total volumn trading
  TV: 'TV',
  AP: 'AP',
  OP: 'OP', // open price
  HI: 'HI', //high
  LO: 'LO', // low
  FB: 'FB',
  FS: 'FS',
  FR: 'FR',
  FO: 'FO',
  TO: 'TO',
  TB: 'TB',
  PP: 'PP',
  SS: 'SS',
}